import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import {
  createCrisisData,
  updateCrisisData,
} from "../../utils/ApiCalls/CrisisData";
import { addlog } from "../../utils/ApiCalls/Logs";
import { LOG_ACTIONS } from "../../utils/Constant/LogConstant";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import DateAndTimePicker from "../DateAndTimePicker";

const CrisisDataInput = ({ crisisdata }) => {
  const [title, setTitle] = useState("");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState("");
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState("");
  const [description, setDescription] = useState("");
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");
  const [traditionalChineseDescripton, setTraditionalChineseDescripton] =
    useState("");
  const [bahasaTitle, setBahasaTitle] = useState("");
  const [bahasaDescription, setBahasaDescription] = useState("");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [vessel, setVessel] = useState("");
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [event_date, setEventDate] = useState("");
  useEffect(() => {
    if (crisisdata) {
      setTitle(crisisdata?.title);
      setSimplifiedChineseTitle(crisisdata?.simplified_chinese_title);
      setTraditionalChineseTitle(crisisdata?.traditional_chinese_title);
      setDescription(crisisdata?.description);
      setSimplifiedChineseDescription(
        crisisdata?.simplified_chinese_description
      );
      setVessel(crisisdata.vessel_id);
      setTraditionalChineseDescripton(
        crisisdata?.traditional_chinese_description
      );
      setBahasaTitle(crisisdata?.bahasa_title || "");
      setBahasaDescription(crisisdata?.bahasa_description || "");
      setEventDate(crisisdata.event_datetime);
    }
  }, [crisisdata]);
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleEnglishTitleChange = (content) => {
    setTitle(content);
  };

  const handleSimplifiedChineseTitleChange = (content) => {
    setSimplifiedChineseTitle(content);
  };

  const handleTraditionalChineseTitleChange = (content) => {
    setTraditionalChineseTitle(content);
  };

  const addcrisisData = async (e) => {
    e.preventDefault();
    let dataValues = {
      title,
      simplified_chinese_title: simplifiedChineseTitle,
      traditional_chinese_title: traditionalChineseTitle,
      description: description,
      simplified_chinese_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescripton,
      bahasa_title: bahasaTitle,
      bahasa_description: bahasaDescription,
      event_datetime: event_date,
      vessel_id: vessel,
    };

    let valid = checkFields(dataValues);

    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (crisisdata?.id) {
        data = await updateCrisisData(crisisdata?.id, values);
      } else {
        data = await createCrisisData(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        return;
      }

      addlog(
        crisisdata?.id ? LOG_ACTIONS.UPDATED : LOG_ACTIONS.CREATED,
        "Crisis Data",
        { id: data?.id || crisisdata?.id, title },
        userDetails.id
      );
      if (!crisisdata?.id) {
        navigate("/website/cms/crisis-page/Crisis-data");
      } else {
        navigate("/website/cms/crisis-page/Crisis-data");
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };
  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcrisisData}>
              <div className="card-body">
                <div className="row">
                  {/* Titles — all 4 languages in one row */}
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Title</label>
                      <ReactQuill
                        value={title}
                        onChange={handleEnglishTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Title</label>
                      <ReactQuill
                        value={simplifiedChineseTitle}
                        onChange={handleSimplifiedChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Title</label>
                      <ReactQuill
                        value={traditionalChineseTitle}
                        onChange={handleTraditionalChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Title</label>
                      <ReactQuill
                        value={bahasaTitle}
                        onChange={(e) => setBahasaTitle(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  {/* Descriptions — all 4 languages in one row */}
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Description</label>
                      <ReactQuill
                        value={description}
                        onChange={(e) => { setDescription(e); }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Description</label>
                      <ReactQuill
                        value={simplifiedChineseDescription}
                        onChange={(e) => setSimplifiedChineseDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Description</label>
                      <ReactQuill
                        value={traditionalChineseDescripton}
                        onChange={setTraditionalChineseDescripton}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Description</label>
                      <ReactQuill
                        value={bahasaDescription}
                        onChange={(e) => setBahasaDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Date time</label>
                      <DateAndTimePicker
                        value={event_date}
                        setValue={(e) => {
                          setEventDate(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Vessel <span style={{ color: "red" }}> *</span>
                      </label>
                      <Select
                        required
                        style={{ width: "100%", height: "45px" }}
                        value={vessel}
                        onChange={(e) => setVessel(e.target.value)}
                      >
                        {vesselOptions.map((item, index) => (
                          <MenuItem key={index + ""} value={item?.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {crisisdata?.id ? "Update" : "Add"} Crisis Data
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default CrisisDataInput;
